import React from 'react'
import ceo from '../../assets/Ceo.png'
import assistant from '../../assets/assistant.png'
import director from '../../assets/director.png'

const Team = () => {
   
    const teams = [
        {
            image: ceo,
            name: "John Doe",
            position: "CEO.Kpoikpoimingi Ltd"
        },
        {
            image: assistant,
            name: "John Doe",
            position: "Personal Assistant"
        },
        {
            image: director,
            name: "John Doe",
            position: "Managing Director"
        },

    ]
  return (
        <section>
            <div className='container md:pl-[61px] md:pr-[57px] text-center'>
                <div className='mt-[115px] mb-[42px] md:mb-[64px]'>
                    <h3 className='text-[14px] md:text-[16px] text-primary md:text-team text-center leading-[20px] md:leading-[24px] tracking-[0.001em] md:tracking-[0.005em] '>Our Team</h3>
                    <h1 className='mt-[4px] md:mt-[24px] text text-center'>Team Members</h1>
                </div>

                    <div className='flex content-center overflow-x-scroll  place-items-center md:overflow-x-hidden overflow-y-hidden scrollbar-hide gap-x-[78px]  md:gap-x-[155px]  md:grid md:grid-cols-2 xl:grid-cols-3 md:gap-y-[40px]'>
                        {teams&&teams.map((team) => (
                                <div className='bg-light w-[271px] md:w-[334px]  hover:scale-105 transform duration-300 ease-in-out'>
                                    <img className='w-full' src={team.image} alt="/" />
                                    <div className='w-[271px] md:w-[334px] h-[79px] md:h-[104px] rounded-br-[5px] rounded-bl-[5px]'>
                                        <h3 className='w-full text-center text-[16px] leading-[24px] mt-[18px] tracking-[0.005em]'>{team.name}</h3>
                                        <p className='w-full text-center text-[16px] leading-[24px]  tracking-[0.005em] mt-[20px]'>{team.position}</p>
                                    </div>
                            </div>
                        ))}
                    </div>
            </div>
        </section>
  )
}

export default Team